module.exports = __webpack_public_path__ + "static/media/lock.bcbfc8d6.svg";